import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../../components/common/faq";

const faqs = [
  {
    question: "How does the Android app development process work?",
    answer: ` <p>There are 7 major steps in the Android app development process, including Strategy Development, Analysis and Planning, UI/UX Design, App Development, Mobile App Testing, Deployment, and Support and Performance Monitoring.</p>`,
  },
  {
    question:
      " What programming languages and tools do you use for Android app development?",
    answer: `<p>The programming languages and tools that TekRevol uses for Android app development in London include Java, Kotlin, C++, and C#. Java has been the official language for Android, but Kotlin has gained popularity among developers for its modern features and user-friendly nature. Additionally, C++ and C# stand out as excellent alternatives for developing native apps.</p>`,
  },
  {
    question: "How long does it take to develop an Android app?",
    answer: `<p>On average, it takes 4 - 6 months to develop an app with average complexity. Here are the details to develop apps with different complexities:</p>  
        <ul>
        <li><strong>Simple App Development :</strong> 2 - 4 months</li>
        <li><strong>Average App Development :</strong> 4 - 6 months</li>
        <li><strong>Complex App Development :</strong> 9+ months</li>
    </ul>`,
  },
  {
    question:
      " How do you ensure the quality and security of the Android apps you develop?",
    answer: `<p>To ensure the quality and security of the Android apps we build, we follow these best practices:</p>  
        <ul>
        <li>Android privacy enhancements over time</li>
        <li>Build apps to be private</li>
        <li>Minimize permissions</li>
        <li>Minimize location access</li>
        <li>Minimize data</li>
        <li>Give users control</li>
        <li>Review what your users see</li>
    </ul>`,
  },
  {
    question: "Can you help in publishing the app on the Google Play Store?",
    answer: `<p>Absolutely! We provide comprehensive support in publishing your app on the Google Play Store. Our team will guide you through the entire process, ensuring a smooth and successful submission.</p>`,
  },
  {
    question: "Do you provide support and maintenance services post-launch?",
    answer: `<p>Certainly! At TekRevol, we understand the importance of ongoing support and maintenance for your app post-launch. We offer dedicated services to address any issues, implement updates, and ensure your app continues to perform at its best.</p>`,
  },
  {
    question:
      "How do you handle data privacy and compliance in your Android apps?",
    answer: `<p>We handle data privacy and compliance issues in Android apps by following the best practices like minimizing the use of APIs that access sensitive or personal user data. Our development process includes robust security measures, encryption protocols, and strict access controls to safeguard user data.
    </p>`,
  },
  {
    question: "What is the cost of developing an Android app?",
    answer: ` <p>There are multiple factors that directly impact the cost of developing an Android app. Just so you don’t overrun your budget, here are the typical figures for various app categories:</p>  
        <ul>
        <li><strong>Simple App :</strong> $20,000 - $50,000</li>
        <li><strong>Medium Complex app :</strong>$50,000 - $150,000</li>
        <li><strong>Highly complex app :</strong> $150,000 - $300,000</li>
    </ul>`,
  },
  {
    question:
      " Can you integrate third-party services/APIs into an Android app?",
    answer: `<p>Yes, one can simply enrich the mobile applications with new features using third party API integration without turning around the wheel. TekRevol specializes in seamlessly integrating third-party services and APIs into Android apps. Whether you require payment gateways, social media integrations, or other external functionalities, our experienced team ensures a smooth and efficient incorporation of these services.</p>`,
  },
  {
    question: "Do you offer customization options for Android apps?",
    answer: ` <p>Yes, TekRevol provides extensive customization options for Android apps to meet your specific needs and preferences.</p>`,
  },
  {
    question: "How do you approach UI/UX design in Android app development?",
    answer: `<p>TekRevol approaches UI/UX design in Android app development by having a deep understanding of your target audience. We conduct user research to learn about their needs, preferences, and pain points. We then utilize this understanding to customize your app's design according to their expectations.</p>`,
  },
  {
    question:
      "What’s your experience with developing Android apps for different industries?",
    answer: `<p>TekRevol has extensive experience in developing Android apps across various industries. Our versatile team has successfully delivered tailored solutions for sectors including healthcare, finance, e-commerce, education, and more.</p>`,
  },
  {
    question: "How do you keep clients updated during the development process?",
    answer: ` <p>We prioritize transparent communication throughout the development process. TekRevol keeps clients updated through regular progress reports, status meetings, and ongoing collaboration. We utilize project management tools and communication channels to share milestones and ensure our clients are informed and involved at every stage of the Android app development journey.</p>`,
  },
  {
    question:
      " What differentiates your company from other Android app development providers?",
    answer: `<p>TekRevol stands out among Android app development providers due to our commitment to practical solutions, transparent communication, and client-centric approach. Our team brings a wealth of experience, ensuring that your project benefits from innovative thinking and industry best practices. We prioritize client satisfaction, delivering results-driven Android app development services tailored to your specific needs. 
    </p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
